import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  Typography,
} from "@material-ui/core";
import {
  SelectValidator,
  TextValidator,
} from "react-material-ui-form-validator";

import { useForm } from "../../../../hooks/useForm";
import { 
  getTiposTransporteDiscapacidad,
  updateSolicitudAdicciones,
  updateSolicitudDiscapacidadTransporte
} from "../../../../actions/adicciones/adiccionesActions";
import { CboLocalidades } from "../../../cbos/CboLocalidades";
import { CboProvincias } from "../../../cbos/CboProvincias";
import { fetchProvincias } from "../../../../actions/cbos/provincias";
import { fetchLocalidades } from "../../../../actions/cbos/localidades";
import { diasSemana } from "../../../../utils/constants";

export const AdiccionesComplementoTransporte = ({setHaveChangeValues, disabled}) => { 
  const dispatch = useDispatch();

  const {
    tiposTransportes,
    solicitudSeleccionada = {},
  } = useSelector((state) => state.adicciones);
  const { items: itemsLocalidades, cargada: localidadesCargadas } = useSelector((state) => state.localidades);
  const { cargada: provinciasCargadas } = useSelector((state) => state.provincias);

  const [idProvinciaDesde, setIdProvinciaDesde] = useState('');
  const [idProvinciaHasta, setIdProvinciaHasta] = useState('');
  const [requiereDias, setRequiereDias] = useState(false);

  let integracionTransporteDefault = {
    idSolicitud: solicitudSeleccionada?.idSolicitud,
    zonaDesfavorable: false,
    calleDesde: '',
    nroDesde: '',
    pisoDesde: '',
    deptoDesde: '',
    codigoPostalDesde: '',
    idLocalidadDesde: '',
    calleHasta: '',
    nroHasta: '',
    pisoHasta: '',
    deptoHasta: '',
    codigoPostalHasta: '',
    idLocalidadHasta: '',
    idTipoTransporte: '',
    lunes: false,
    martes: false,
    miercoles: false,
    jueves: false,
    viernes: false,
    sabado: false,
    horarios: ''
  };

  const [
    formValues,
    handleInputChange,
    ,
    ,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    !!solicitudSeleccionada?.integracionTransporte 
      ? solicitudSeleccionada.integracionTransporte 
      : integracionTransporteDefault
  );

  const {
    zonaDesfavorable,
    calleDesde,
    nroDesde,
    pisoDesde,
    deptoDesde,
    codigoPostalDesde,
    idLocalidadDesde,
    calleHasta,
    nroHasta,
    pisoHasta,
    deptoHasta,
    codigoPostalHasta,
    idLocalidadHasta,
    idTipoTransporte
  } = formValues;

  const errorDias = requiereDias && (!formValues.lunes&& !formValues.martes&& !formValues.miercoles&& 
    !formValues.jueves&& !formValues.viernes&& !formValues.sabado);

  useEffect(() => {
    if(!provinciasCargadas) dispatch(fetchProvincias());
  }, [dispatch, provinciasCargadas]);

  useEffect(() => {
    if(!localidadesCargadas) dispatch(fetchLocalidades());
  }, [dispatch, localidadesCargadas]);

  useEffect(() => {
    dispatch(getTiposTransporteDiscapacidad());
  }, [dispatch]);

  useEffect(() => {
    if(idTipoTransporte !== '' && tiposTransportes.find(s => s.idTipoTransporte === idTipoTransporte)?.requiereDias){
      setRequiereDias(true);
    } else {
      setRequiereDias(false);
    }
  }, [idTipoTransporte, tiposTransportes]);

  useEffect(() => {
    if(idLocalidadDesde){
      const listaFiltrada = itemsLocalidades
        .filter(loc => codigoPostalDesde?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(codigoPostalDesde));
      if(listaFiltrada?.length > 0){
        const locDesde = listaFiltrada[0];
        setIdProvinciaDesde(locDesde?.id_provincia);
      }
    }
  }, [idLocalidadDesde, codigoPostalDesde, localidadesCargadas]);

  useEffect(() => {
    if(idLocalidadHasta){
      const listaFiltrada = itemsLocalidades
        .filter(loc => codigoPostalHasta?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(codigoPostalHasta));
      if(listaFiltrada?.length > 0){
        const locHasta = listaFiltrada[0];
        setIdProvinciaHasta(locHasta?.id_provincia);
      }
    }
  }, [idLocalidadHasta, codigoPostalHasta, localidadesCargadas]);

  const handleCPChange = (e, hasta = false) => {    
    let reg = new RegExp("^[0-9]+$");
    const cp = e.target.value;
    if (cp === '' || reg.test(cp)) {
      let changeObj = !hasta
        ? 
          {
            codigoPostalDesde: cp,
            idLocalidadDesde: ''
          }
        :
          {
            codigoPostalHasta: cp,
            idLocalidadHasta: ''
          };
      let entriesObj = Object.entries(changeObj);
      // let changeIdProv = '';
      const listaFiltrada = itemsLocalidades.filter(loc => cp?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(cp));
      if(listaFiltrada?.length > 0){
        const localidad = listaFiltrada[0];
        changeObj[entriesObj[1][0]] = localidad?.id_localidad;
        // changeIdProv = localidad?.id_provincia;
      }
      // if(!hasta)
      //   setIdProvinciaDesde(changeIdProv);
      // else
      //   setIdProvinciaHasta(changeIdProv);        
      setearVariosValores({...changeObj});
      if(!solicitudSeleccionada.integracionTransporte){
        dispatch(updateSolicitudAdicciones('integracionTransporte', integracionTransporteDefault));
      }
      dispatch(updateSolicitudDiscapacidadTransporte(entriesObj[0][0], changeObj[entriesObj[0][0]]));
      dispatch(updateSolicitudDiscapacidadTransporte(entriesObj[1][0], changeObj[entriesObj[1][0]]));      
    }
  };

  const handleInputChangeTransporte = (name, value) => {        
    if(!solicitudSeleccionada.integracionTransporte){
      dispatch(updateSolicitudAdicciones('integracionTransporte', integracionTransporteDefault));
    }
    dispatch(updateSolicitudDiscapacidadTransporte(name, value));                                  
    handleInputChange({target: {name: name, value: value}})
    setHaveChangeValues(true);
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        justify="center"
        style={{marginBottom: 10}}
      >
        <Grid item xs={6} md={4} >
          <FormControlLabel
            style={{marginTop: 15}}
            control={
              <Checkbox
                name="zonaDesfavorable"
                disabled={disabled}
                checked={zonaDesfavorable}
                onClick={(e) => handleInputChangeTransporte(e.target.name, e.target.checked)}
              />
            }
            label="Zona Desfavorable"
          />
        </Grid>
        <Grid item xs={6}>
          <SelectValidator
            fullWidth
            margin="normal"
            label="Tipo de Transporte"
            name="idTipoTransporte"
            value={idTipoTransporte ?? ''}
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            disabled={disabled}
            validators={["required"]}
            errorMessages={["Este campo es requerido"]}
            style={{marginTop: 10}}
          >
            {tiposTransportes.map((item) => (
              <MenuItem
                key={item.idTipoTransporte}
                value={item.idTipoTransporte}
              >
                {item.descripcion}
              </MenuItem>              
            ))}
          </SelectValidator>
        </Grid>
        {requiereDias&&
          <Grid item xs={12} style={{maxWidth: 700}} >
            <Paper style={{marginTop: 5, textAlign: 'center'}}>
                <FormControl required error={errorDias} component="fieldset" >
                    <FormGroup row>
                        {diasSemana.filter(s => s.value !== 'DO').map((item) => (
                            <FormControlLabel
                                key={item.value}
                                control={
                                <Checkbox
                                    name={item.value2}
                                    checked={formValues[item.value2]}
                                    onClick={(e) => handleInputChangeTransporte(item.value2, e.target.checked)}
                                    disabled={disabled}
                                />
                                }
                                label={item.display}
                            />
                        ))}
                    </FormGroup>
                    {errorDias&&
                        <FormHelperText style={{textAlign: 'center'}}>Debe seleccionar por lo menos un día</FormHelperText>
                    }
                </FormControl>
                <Grid style={{ marginLeft: '2rem', marginRight: '2rem' }}>
            <TextValidator
              margin="normal"
              value={formValues.horarios ?? ''}
              inputProps={{ style: { textTransform: "uppercase" } }}
              label="Horarios"
              name="horarios"
              onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
              autoComplete="off"
              disabled={disabled}
              fullWidth
            />
          </Grid>
            </Paper>
          </Grid>
        }
      </Grid>
      <Typography variant='button'  style={{marginLeft: -20}}>
        Domicilio Desde
      </Typography>
      <Grid
        container
        spacing={2}
        style={{marginBottom: 25}}
        // style={{ display: "flex", justifyContent: "center" }}
      >
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            value={calleDesde ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Calle Desde"
            name="calleDesde"
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            disabled={disabled}
            fullWidth
            validators={
              [
                "isString", 
                "required"
              ]
            }
            errorMessages={
              [
                "Debe ser una cadena de texto", 
                "La calle es requerida"
              ]
            }
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={nroDesde ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Nro Desde"
            name="nroDesde"
            disabled={disabled}
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            fullWidth
          //validators={numeroValidator}
          //errorMessages={numeroErrorMessage}
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={pisoDesde ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Piso"
            name="pisoDesde"
            disabled={disabled}
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            fullWidth
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={deptoDesde ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Depto."
            name="deptoDesde"
            disabled={disabled}
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            fullWidth
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={codigoPostalDesde ?? ''}
            onChange={handleCPChange}
            label="Cod. Postal"
            disabled={disabled}
            name="codigoPostalDesde"
            inputProps={{ maxLength: 4 }}
            autoComplete="off"
            validators={["required"]}
            errorMessages={["El codigo postal es requerido"]}
          />
        </Grid>
        <Grid item xs={8} md={5}>
          <CboLocalidades
            manejadorInputChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            name="idLocalidadDesde"
            disabled={disabled}
            valor={idLocalidadDesde}
            cp={codigoPostalDesde}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <CboProvincias
            valor={idProvinciaDesde}
            name="idProvinciaDesde"
          />
        </Grid>
      </Grid>
      <Typography variant='button'  style={{marginLeft: -20}}>
        Domicilio Hasta
      </Typography>
      <Grid
        container
        spacing={2}
        // style={{ display: "flex", justifyContent: "center" }}
      >
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            value={calleHasta ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Calle Hasta"
            name="calleHasta"
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            disabled={disabled}
            fullWidth
            validators={
              [
                "isString", 
                "required"
              ]
            }
            errorMessages={
              [
                "Debe ser una cadena de texto", 
                "La calle es requerida"
              ]
            }
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={nroHasta ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Nro Hasta"
            name="nroHasta"
            disabled={disabled}
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            fullWidth
            //validators={numeroValidator}
            //errorMessages={numeroErrorMessage}
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={pisoHasta ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Piso"
            name="pisoHasta"
            disabled={disabled}
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            fullWidth
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={deptoHasta ?? ''}
            inputProps={{ style: { textTransform: "uppercase" } }}
            label="Depto."
            name="deptoHasta"
            disabled={disabled}
            onChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            autoComplete="off"
            fullWidth
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <TextValidator
            margin="normal"
            value={codigoPostalHasta ?? ''}
            onChange={(e) => handleCPChange(e, true)}
            label="Cod. Postal"
            disabled={disabled}
            name="codigoPostalHasta"
            inputProps={{ maxLength: 4 }}
            autoComplete="off"
            validators={["required"]}
            errorMessages={["El codigo postal es requerido"]}
          />
        </Grid>
        <Grid item xs={8} md={5}>
          <CboLocalidades
            manejadorInputChange={(e) => handleInputChangeTransporte(e.target.name, e.target.value)}
            name="idLocalidadHasta"
            disabled={disabled}
            valor={idLocalidadHasta}
            cp={codigoPostalHasta}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <CboProvincias
            valor={idProvinciaHasta}
            name="idProvinciaHasta"
          />
        </Grid>
      </Grid>
    </>
  )
}
